module.exports = __webpack_public_path__ + "static/media/ms1Final_img-min.46bc8af7.jpg";